import { IColorStyles } from "@gn-audio/angularjs-components/color-dots/models/color-styles";
import { getColorStyles } from "@gn-audio/angularjs-components/color-dots/utilities/get-color-styles";

const colorAttribute = 'product_mobcolorhex';
const size = 16;

export class ColorDotsService {
  private colorDots?: IColorStyles[] = [];

  public getColorDotsHTMLElement(attributes: string[]): string {
    this.colorDots = this.parseColorDots(attributes);
    if (!this.colorDots || this.colorDots.length < 2)
      return '';
    
    return this.buildColorDotsHTMLElement();
  }

  private parseColorDots(attributes: string[]): IColorStyles[] {
    return attributes
      .filter((attribute: string) => attribute.toLowerCase()
        .indexOf(colorAttribute) === 0)
      .filter((attribute: string, index: number, self: string[]) => self.indexOf(attribute) === index)
      .map((attribute: string) => attribute.split('|')
        .slice(1)
        .join('|'))
      .map(getColorStyles);
  }

  private buildColorDotsHTMLElement(): string {
    let colorDotsList: string = '';
    this.colorDots.forEach((colorDot) => {
      let colorDotStyles = '';
      for (const [styleName, value] of Object.entries(colorDot)) {
        colorDotStyles += `${styleName}: ${value};`;
      }

      colorDotsList += `<li class="color-dots__dot">
                          <i style="${colorDotStyles}"></i>
                        </li>`;
    });

    return `<ul class="color-dots color-dots--size-${size}">
              ${colorDotsList}
            </ul>`;
  }
}
